<!--
 * @Author: huanglin.like@qq.com
 * @LastEditTime: 2024-01-05 11:44:12
-->
<template>
  <com-page>
    <com-search :columns="searchColumns" @search="handleSearch">
      <template>
        <el-button type="primary" @click="handleBatch">上传</el-button>
      </template>
    </com-search>
    <com-card class="mt-15px">
      <com-table class="mt-15px" :columns="columns" :api="api" ref="table">
        <template #operation="row">
          <div class="flex">
            <el-button type="primary" size="mini" @click="handleWatch(row.data)">详情</el-button>
          </div>
        </template>
        <template #createTime="row">
          {{ row.data.createTime | formatDate }}
        </template>
      </com-table>
    </com-card>
    <the-ota-detail ref="otaDetailRef" @success="$refs.table.reset()" />
  </com-page>
</template>

<script>
import { otaListApi } from '@/api/equ'
import theOtaDetail from './components/the-ota-detail'

export default {
  components: { theOtaDetail },
  data() {
    return {
      searchColumns: [
        {
          label: '版本号/名称',
          type: 'input',
          prop: 'name'
        },
        {
          label: '生成时间',
          type: 'date',
          prop: 'date'
        }
      ],
      columns: [
        {
          label: '版本号',
          prop: 'updateVersion'
        },
        {
          label: '版本名称',
          prop: 'name'
        },

        {
          label: '生成时间',
          prop: 'createTime',
          type: 'slot',
          slotName: 'createTime'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation',
          width: '180'
        }
      ],
      api: otaListApi
    }
  },
  methods: {
    handleWatch(row) {
      this.$refs.otaDetailRef.open('detail', row)
    },
    handleSearch(e) {
      this.$refs.table.search(e)
    },
    handleBatch() {
      this.$refs.otaDetailRef.open('created')
    }
  }
}
</script>

<style lang="scss" scoped></style>
